import {
  SHOW_NOTIFICATION_ALERT
} from 'constants/ActionTypes';

export const ShowNotificationAlert = (alert) => {
  return {
    type: SHOW_NOTIFICATION_ALERT,
    payload: alert
  };
};